import { useCallback } from 'react';

import { useEmitterContext } from '../context';

export const useGetTriggerCondition = () => {
    const { triggerCondition } = useEmitterContext();

    return useCallback((condition) => {
        triggerCondition(condition);

    }, [triggerCondition]);
};
